import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { CATEGORIES } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <img
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_seekho-admin/artifacts/2biwyt6k_6305294127389675025.jpg"
              alt="Ecom Seekho"
              className="w-10 h-10 rounded-md object-cover"
            />
            <span className="font-bold text-xl text-white">Ecom Seekho</span>
          </div>
          <p className="text-sm text-gray-400">
            India's trusted wholesale marketplace for household, kitchen & utility products at factory prices.
          </p>
          <div className="flex gap-3 mt-4">
            <a href="#" className="w-8 h-8 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-8 h-8 rounded-full bg-gray-800 hover:bg-orange-500 flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-8 h-8 rounded-full bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.slice(0, 6).map((c) => (
              <li key={c.id}>
                <Link to={`/shop?category=${c.id}`} className="hover:text-emerald-400 transition-colors">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="hover:text-emerald-400 transition-colors">About Us</a></li>
            <li><a href="#" className="hover:text-emerald-400 transition-colors">Contact</a></li>
            <li><a href="#" className="hover:text-emerald-400 transition-colors">Bulk Enquiry</a></li>
            <li><a href="#" className="hover:text-emerald-400 transition-colors">Shipping Policy</a></li>
            <li><a href="#" className="hover:text-emerald-400 transition-colors">Return Policy</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-emerald-400" /><span>+91 78803 99081</span></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-emerald-400" /><span>support@ecomseekho.in</span></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-emerald-400" /><span>Gorakhpur, Uttar Pradesh, India</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4 text-xs text-gray-500 flex flex-col md:flex-row justify-between gap-2">
          <span>© 2025 Ecom Seekho. All rights reserved.</span>
          <span>Prices are exclusive of GST | Wholesale only</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
